module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "vivid-arts-directory"
  }, [(!_vm.directory) ? _c('pulse-loader', {
    staticClass: "va-page-loader",
    attrs: {
      "color": _vm.color,
      "size": _vm.size,
      "margin": _vm.margin,
      "radius": _vm.radius
    }
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.enterpriseLogo) ? _c('v-flex', {
    staticClass: "page-header mb-5",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card-media', {
    staticClass: "enterprise-logo",
    attrs: {
      "src": _vm.enterpriseLogo,
      "contain": _vm.enterpriseLogoContain,
      "height": "100px"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.directory && _vm.directory.enableHero && _vm.directory.gallery && _vm.directory.gallery.length) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.directory.gallery), function(item, i) {
    return _c('swiper-slide', {
      key: i,
      attrs: {
        "src": item.src
      }
    }, [(item.url) ? _c('a', {
      attrs: {
        "href": item.url
      }
    }, [_c('div', {
      staticClass: "slider-img",
      style: ({
        backgroundImage: 'url(' + item.src + ')'
      })
    }), _vm._v(" "), (item.caption) ? _c('div', {
      staticClass: "slider-caption-wrap"
    }, [_c('div', {
      staticClass: "caption-text"
    }, [_vm._v("\n                " + _vm._s(item.caption) + "\n              ")])]) : _vm._e()]) : _c('div', [_c('div', {
      staticClass: "slider-img",
      style: ({
        backgroundImage: 'url(' + item.src + ')'
      })
    }), _vm._v(" "), (item.caption) ? _c('div', {
      staticClass: "slider-caption-wrap"
    }, [_c('div', {
      staticClass: "caption-text"
    }, [_vm._v("\n                " + _vm._s(item.caption) + "\n              ")])]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev swiper-button-white",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next swiper-button-white",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "artist-search mt-5",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('p', {
    staticClass: "headline"
  }, [_vm._v("Filters")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "search-textfield-wrap",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "search-textfield",
    attrs: {
      "name": "input-1-3",
      "label": "Search Artist",
      "single-line": "",
      "prepend-icon": "search"
    },
    model: {
      value: (_vm.artistSearch),
      callback: function($$v) {
        _vm.artistSearch = $$v
      },
      expression: "artistSearch"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.artistSearch),
      expression: "artistSearch"
    }],
    staticClass: "clear-search btn",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.artistSearch = ''
      }
    }
  }, [_c('v-icon', [_vm._v("fa-times-circle")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.viewableArtists.length) + "/" + _vm._s(_vm.fRegions.length))]), _vm._v(" "), _c('p', [_vm._v("Region")]), _vm._v(" "), _c('v-select', {
    staticClass: "capitalize",
    attrs: {
      "items": _vm.cities,
      "overflow": "",
      "label": "Select"
    },
    model: {
      value: (_vm.dd1),
      callback: function($$v) {
        _vm.dd1 = $$v
      },
      expression: "dd1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('p', [_vm._v("Type")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.activeCategories,
      "overflow": "",
      "item-value": "name",
      "item-text": "name",
      "label": "Select"
    },
    model: {
      value: (_vm.dd2),
      callback: function($$v) {
        _vm.dd2 = $$v
      },
      expression: "dd2"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    ref: "artistGridWrap",
    attrs: {
      "xs12": "",
      "id": "artist-grid-wrap"
    }
  }, [_c('v-container', _vm._b({
    attrs: {
      "fluid": ""
    }
  }, 'v-container', ( _obj = {}, _obj["grid-list-md"] = true, _obj ), false), [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.viewableArtists), function(artist) {
    return (_vm.viewableArtists.length > 0) ? _c('v-flex', {
      key: artist.permalink,
      staticClass: "pa-4",
      class: _vm.itemClassSize,
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-card', {
      attrs: {
        "flat": "",
        "tile": ""
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'ArtistProfile',
          params: {
            id: artist.permalink
          }
        }
      }
    }, [_c('v-card-media', {
      staticClass: "profile-image",
      attrs: {
        "src": _vm._f("thumbnailURL")(artist.profileURL),
        "height": "200px"
      }
    })], 1), _vm._v(" "), _c('v-card-title', {
      attrs: {
        "primary-title": ""
      }
    }, [_c('div', [_c('router-link', {
      staticClass: "artist-name",
      attrs: {
        "to": {
          name: 'ArtistProfile',
          params: {
            id: artist.permalink
          }
        }
      }
    }, [_c('h3', {
      staticClass: "headline mb-0"
    }, [_vm._v(_vm._s(artist.fullName))])]), _vm._v(" "), _c('div', {
      staticClass: "artist-expcert"
    }, [_vm._v(_vm._s(_vm._f("truncate")(artist.excerpt, 150)))])], 1)]), _vm._v(" "), _c('v-card-actions', [_c('router-link', {
      staticClass: "indigo--text btn btn--flat",
      attrs: {
        "tag": "button",
        "to": {
          name: 'ArtistProfile',
          params: {
            id: artist.permalink
          }
        }
      }
    }, [_vm._v("View Profile")])], 1)], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.viewableArtists.length === 0) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "headline text-xs-center"
  }, [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (_vm.viewableArtists.length) ? _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.numberOfPages,
      "circle": ""
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1) : _vm._e()], 2)], 1)], 1)], 1)], 1)
  var _obj;
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e91861dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Artists/Directory.vue
// module id = 619
// module chunks = 1